export default __webpack_public_path__ + "static/media/d.f02f0261.png";